module.exports = __webpack_public_path__ + "static/media/quiz-login-hero.e4bc5f2d.jpeg";